import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c1de326a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ads-account-sidebar"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "modal-paragraph"
}, " Your advertising account is connected to these countries ", -1));
const _hoisted_3 = {
  class: "account-info"
};
const _hoisted_4 = {
  class: "connected-advertisers"
};
const _hoisted_5 = {
  class: "countries"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  class: "profileid"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Adding a new country will require reauthorization with Amazon Advertising Central", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_td = _resolveComponent("b-td");
  const _component_app_button = _resolveComponent("app-button");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_custom_side_bar_app_modal = _resolveComponent("custom-side-bar-app-modal");
  return _openBlock(), _createBlock(_component_custom_side_bar_app_modal, {
    title: `Advertising account`,
    noOk: "",
    noCancel: "",
    noFooter: "",
    custom_class: "ads-account-sidebar-modal"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_b_row, null, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "6"
      }, {
        default: _withCtx(() => [_createTextVNode(" Account Name "), _createElementVNode("p", null, _toDisplayString($props.account.account_name), 1)]),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "6"
      }, {
        default: _withCtx(() => [_createTextVNode(" Seller ID "), _createElementVNode("p", null, _toDisplayString($props.account.selling_partner_id), 1)]),
        _: 1
      })]),
      _: 1
    })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_b_row, {
      style: {
        "height": "21px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        cols: "8"
      }, {
        default: _withCtx(() => [_createTextVNode("CONNECTED ADVERTISERS")]),
        _: 1
      }), _createVNode(_component_b_col, {
        cols: "4",
        class: "resynchronize",
        onClick: _cache[0] || (_cache[0] = $event => $options.onConnect())
      }, {
        default: _withCtx(() => [_createVNode(_component_app_icon, {
          icon: "resynchronize",
          color: "#616161",
          class: "reset-icon"
        }), _createTextVNode(" Resynchronize")]),
        _: 1
      })]),
      _: 1
    }), _createElementVNode("div", _hoisted_5, [_createVNode(_component_b_table_simple, {
      style: {
        "margin-bottom": "0px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_b_tbody, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.profiles, profile => {
          return _openBlock(), _createBlock(_component_b_tr, {
            class: "country",
            key: profile.profileId
          }, {
            default: _withCtx(() => [_createVNode(_component_b_td, null, {
              default: _withCtx(() => [_createElementVNode("img", {
                class: "flag",
                src: _ctx.getCountryFlag(profile.countryCode),
                alt: profile.country
              }, null, 8, _hoisted_6)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(profile.countryCode === "UK" || profile.countryCode === "GB" ? "UK" : $options.flipCountry(profile.countryCode)) + " ", 1), _createElementVNode("p", _hoisted_7, _toDisplayString(profile.profileId), 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "align-middle"
            }, {
              default: _withCtx(() => [!_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                loading: profile.profileId == $data.removeId ? $data.removeLoading : null,
                variant: "link",
                onClick: $event => $options.onRemove(profile.profileId)
              }, {
                default: _withCtx(() => [_createVNode(_component_app_icon, {
                  icon: "remove",
                  color: "#D1D1D1"
                })]),
                _: 2
              }, 1032, ["loading", "onClick"])) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128)), !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_b_tr, {
          key: 0,
          onClick: _cache[1] || (_cache[1] = $event => $options.onConnect()),
          class: "country add-new rounded-bottom"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_td, null, {
            default: _withCtx(() => [_createVNode(_component_app_icon, {
              icon: "plus",
              color: "#484C51",
              size: "20"
            })]),
            _: 1
          }), _createVNode(_component_b_td, null, {
            default: _withCtx(() => [_createTextVNode(" Add new "), _hoisted_8]),
            _: 1
          }), _createVNode(_component_b_td)]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    })])]), _createVNode(_component_app_modal, {
      modelValue: $data.confirmRemoveModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.confirmRemoveModal = $event),
      title: "Confirm Account Removing",
      "cancel-title": "No",
      "ok-title": "Yes",
      onOk: $options.onRemoveConfirm
    }, {
      default: _withCtx(() => [_createTextVNode(" Are you sure you want to remove this country? ")]),
      _: 1
    }, 8, ["modelValue", "onOk"])])]),
    _: 1
  });
}